/* unplugin-vue-components disabled */import { render } from "./MoblieScorePanel.vue?vue&type=template&id=483322ee&scoped=true"
import script from "./MoblieScorePanel.vue?vue&type=script&lang=js"
export * from "./MoblieScorePanel.vue?vue&type=script&lang=js"

import "./MoblieScorePanel.vue?vue&type=style&index=0&id=483322ee&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483322ee"]])

export default __exports__